export default __webpack_public_path__ + "static/media/atlanta-usa.7b5ea1b3.jpg";